// Import model
import { BitwiseFlagFieldOptions } from '../models/BitwiseFlagFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for BitwiseFlagFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class BitwiseFlagFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a BitwiseFlagFieldOptions instance
   */
  static deserialize(json: string): BitwiseFlagFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a BitwiseFlagFieldOptions instance
   */
  static fromObject(obj: any): BitwiseFlagFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to BitwiseFlagFieldOptions');
    }


    const instance: BitwiseFlagFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      items: obj['Items'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of BitwiseFlagFieldOptions instances
   */
  static deserializeArray(json: string): BitwiseFlagFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a BitwiseFlagFieldOptions instance to a JSON string
   */
  static serialize(instance: BitwiseFlagFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a BitwiseFlagFieldOptions instance to a plain object
   */
  static toObject(instance: BitwiseFlagFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'Items': instance.items,
    };
  }

  /**
   * Serializes an array of BitwiseFlagFieldOptions instances to a JSON string
   */
  static serializeArray(instances: BitwiseFlagFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
